module.exports = __webpack_public_path__ + "media/images/shark/SharkMainImage-p-800-697d1893c1ad6dd499b0f0f531d3aba8.jpg";